import React from "react";
import BarChart from "../../../reusableComponents/BarChart/BarChart";

const ResultPositionSize = ({data}) => {


  const isEmpty = !data || Object.keys(data).length === 0;

  const categories = isEmpty ? [] : Object.keys(data);

  const numberOfTrades = isEmpty
    ? []
    : categories.map((key) => data[key]?.number_of_trade || 0);

  const results = isEmpty
    ? []
    : categories.map((key) => data[key]?.results || 0);

  const lots = isEmpty
    ? []
    : categories.map((key) => data[key]?.lots || 0);

  const seriesData = [
    {
      name: "Number of Trades",
      data: numberOfTrades,
      label: "no_of_trades",
    },
    {
      name: "Results",
      data: results,
      label: "amount",
    },
    {
      name: "Lots",
      data: lots,
      label: "lots",
    },
  ];

  return (
    <div className="resultPositionSizeMain">
      <div className="trade-reports">
        <div className="header_Wrapper">
          <h2 className="component-heading">Results by Position Size</h2>
        </div>
        <div className="chart-box-wrapper">
          <div className="tabs-wrapper tabs-1">
            <div className="chart-box">
              <BarChart
                seriesData={seriesData}
                categories={categories}
                dataSymbol="amount"
                graphType="Results, Trades, Lots"
                title="Position Size"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultPositionSize;
